<template>
  <div class="user contentPadding42" id="ManageTable">
    <div class="userManage_header">
      <div class="userManage_logo">
        <img src="@/assets/imgs/icon/graden_logo.png" alt />
      </div>
      <h3>园区基本信息</h3>
    </div>

    <div class="content">
      <div class="content_ul">
        <div class="lineTitle margin0">
          <span>基本信息</span>
        </div>
        <div class="content_li">
          <dl>
            <dt>园区代码</dt>
            <dd>{{gardenInfo.code}}</dd>
          </dl>
          <dl>
            <dt>园区名称</dt>
            <dd>{{gardenInfo.name}}</dd>
          </dl>
          <dl>
            <dt>园区类型</dt>
            <dd>{{gardenInfo.type}}</dd>
          </dl>
          <dl>
            <dt>园区级别</dt>
            <dd>{{gardenInfo.level}}</dd>
          </dl>
        </div>
        <div class="content_li">
          <dl>
            <dt>所在区县</dt>
            <dd>{{gardenInfo.seat}}</dd>
          </dl>
          <dl>
            <dt>状态</dt>
            <dd v-if="gardenInfo.state==1">停用</dd>
            <dd v-if="gardenInfo.state==0">启用</dd>
          </dl>
          <dl>
            <dt>园区用户名</dt>
            <dd>{{loginName}}</dd>
          </dl>
        </div>
        <div class>
          <dl style="width:80%">
            <dt>园区简介</dt>
            <dd>{{gardenInfo.introduction}}</dd>
          </dl>
        </div>
      </div>
      <div class="conten_logo"></div>
    </div>
    <!-- 园区信息修改 -->
    <el-dialog
      title="园区信息修改"
      :visible.sync="editDialogVisible"
      class="dialog1020 titleChange"
      :close-on-click-modal="false"
      @closed="editHandleClose"
    >
      <div class="lineTitle">
        <span>基本信息</span>
      </div>
      <el-form
        :inline="true"
        :model="editObj"
        class="demo-form-inline half radioMarginTop7 textarea150"
        size="mini"
        label-width="82px"
        label-position="right"
        ref="editForm"
        v-loading="editLoading"
      >
        <el-form-item label="园区代码" style="width:45%">
          <el-input v-model="editObj.code" placeholder disabled></el-input>
        </el-form-item>
        <el-form-item label="园区名" style="width:45%">
          <el-input v-model.trim="editObj.name" placeholder="请输入" disabled></el-input>
        </el-form-item>
        <el-form-item label="园区类型" style="width:45%">
          <el-select v-model="editObj.type" placeholder="请选择">
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="园区级别" style="width:45%">
          <el-select v-model="editObj.level" placeholder="请选择">
            <el-option
              v-for="item in levelList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="editObj.state" disabled>
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="注册区县" style="width:45%" class="selection_item">
          <el-select v-model="editObj.seat" placeholder="请选择">
            <el-option
              v-for="item in seatList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="园区用户名" style="width:45%">
          <el-input v-model.trim="loginName" placeholder disabled></el-input>
        </el-form-item>
        <el-form-item label="园区简介" style="width:100%">
          <el-input type="textarea" v-model.trim="editObj.introduction" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item style="width:100%;">
          <div class="btnBox">
            <el-button type="primary" size="mini" class="bg5584FF" @click="sureAdd('addForm')">确定</el-button>
            <el-button type="normal" size="mini" @click="editDialogVisible = false">取消</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from "element-ui";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      editDialogVisible: false,
      editLoading: false,
      dialogVisible: false,
      loginName: "",
      dialogImageUrl: "",
      userName: "",
      levelList: "",
      typeList: "",
      editObj: {
        //提交表单
        state: 0
      },
      gardenInfo: {},
      rules: {
        //表单验证规则
      }
    };
  },
  created() {
    this.getData();
    this.getSelectList();
    this.loginName = sessionStorage.getItem("loginName");
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists"
    })
  },
  methods: {
    getData() {
      this.$axios.get("/business/myPark/selectParkNames").then(res => {
        this.gardenInfo = res.data;
      });
    },
    // 获取下拉框选项
    getSelectList() {
      // 园区级别
      this.$axios
        .get("/business/park/Level")
        .then(res => {
          this.levelList = res.data;
        })
        .catch(res => {
          console.log("园区级别列表获取失败", res);
        });
      // 园区类型
      this.$axios
        .get("/business/park/type")
        .then(res => {
          this.typeList = res.data;
        })
        .catch(res => {
          console.log("园区类型列表获取失败", res);
        });
    },
    gardenDialogVisible() {
      this.editDialogVisible = true;
      this.$axios.get("/business/myPark/selectParkNames").then(res => {
        this.editObj = res.data;
      });
    },
    editHandleClose() {
      this.$refs.editForm.resetFields();
    },
    sureAdd(formNmae) {
      this.editLoading = true;
      this.$axios
        .put("/business/myPark/updateParkInfo", this.editObj)
        .then(res => {
          Message.success("已修改");
          this.editLoading = false;
          this.editDialogVisible = false;
          this.getData();
        })
        .catch(() => {
          this.editLoading = false;
        });
    },
    handleRemove(file, fileList) {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="less" scoped>
.userManage_header {
  height: 61px;
  width: 100%;
  display: flex;
  border-bottom: 1px solid rgba(155, 155, 155, 0.25);
  margin-bottom: 40px;
  .userManage_logo {
    margin: 2px 20px 0 2px;
  }
  h3 {
    font-size: 24px;
    height: 100%;
    margin: 0;
    color: #444444;
  }
}
.userManage_add_user {
  margin-bottom: 40px;
}
.content {
  width: 100%;
  height: 100%;
  display: flex;
  .content_ul {
    flex: 1;
    box-sizing: border-box;
    padding-right: 15px;
    dl {
      width: 24%;
      box-sizing: border-box;
      padding: 25px 0;
      dt {
        color: rgba(102, 102, 102, 1);
        font-size: 12px;
        margin-bottom: 11px;
      }
      dd {
        font-size: 16px;
        text-align: left;
        margin: 0 !important;
        font-weight: 500;
      }
    }
    .content_li {
      display: flex;
      height: 102px;
      border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    }
  }
  // .conten_logo {
  //   width: 523px;
  //   height: 368px;
  //   box-sizing: border-box;
  //   padding: 33px 0;
  // }
}
</style>